import gql from 'graphql-tag';

export default gql`
    query GetJobPlannedStages($jobId: Int!) {
        getJobPlannedStages(jobId: $jobId) {
            id
            jobId
            fromDate
            toDate
            stagesPerDay
            updatedBy
            updatedDate
        }
    }
`;
